/**
 * Bloco da seção "Nossos serviços" do site.
 *
 * É conteúdo editorial, não o catálogo de "Ferramentas > Serviços": preço,
 * duração e agendabilidade continuam vindo de lá.
 */
export class ProfileService {
    profileServiceId: string
    /** título do card */
    headline: string
    /** linha de apoio, sob o título */
    subheadline?: string
    /** texto longo, exibido só quando o visitante abre o serviço */
    content?: string
    /** enquanto não salvo vem como base64; a api devolve a URL */
    image?: string
    /** ordem na home. definida pela posição na lista */
    position?: number
    status: number
    createdAt: Date
    updatedAt: Date
    companyId: string
}
